<div class="content">
  <div class="celo-dialog-header">
    <h1 mat-dialog-title>Verify Mobile Number</h1>
    <button
      mat-icon-button
      class="celo-dialog-close"
      aria-label="Close"
      [mat-dialog-close]="false"
    >
      <i class="material-icons">close</i>
    </button>
  </div>
  <div mat-dialog-content class="body">
    <div class="img appear_anim_1">
      <img src="../../../assets/phone-number.svg" alt="" />
    </div>
    <div class="title">We need to confirm your number</div>
    <div class="celo-grey text">
      We’ve sent a 6-digit confirmation code to {{ data.countryCode }}
      {{ data.phoneNumber }}. Didn’t receive a code?
      <a
        (click)="verifyNumber(data.countryCode, data.phoneNumber)"
        class="celo-link"
        >Resend Code</a
      >.
    </div>
    <div class="fields celo-input-outline">
      <mat-form-field class="number fw" appearance="outline">
        <input
          matInput
          [(ngModel)]="data.code"
          placeholder="Enter code"
          class="fw"
        />
      </mat-form-field>
    </div>
  </div>
  <div mat-dialog-actions>
    <button
      mat-button
      [disabled]="!data.code || submitting"
      class="celo-primary-button fw"
      (click)="verifyCode(data.code, data.countryCode, data.phoneNumber)"
      cdkFocusInitial
    >
      VERIFY MY NUMBER
    </button>
  </div>
</div>
